/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-04-27 17:00:49
 * @LastEditors: shenlin
 * @LastEditTime: 2022-10-10 15:28:47
 */
const BASE_URL = '/lishui-gov'
const BASE = '/dev-api'
import request from '@/common/api/request'
// 企业认证列表页列表
export const listByPage = params =>
  request(BASE_URL + '/serviceCoupon/serviceCouponList', { params })
// 修改状态
export const upAndDownOperate = params =>
  request(BASE_URL + '/serviceCoupon/changeStatus', { params })
// 删除服务券
export const deleteOperate = params =>
  request(BASE_URL + '/serviceCoupon/deleteCoupon', { params })
// 领券记录
export const getRecordsList = params =>
  request(BASE_URL + '/serviceCoupon/couponRecordList', { params })

// 分发券
export const distributeCoupon = data =>
  request.post(BASE_URL + '/serviceCoupon/distributeCoupon', data)
// 校验券是否重名
export const checkCouponName = params =>
  request(BASE_URL + '/serviceCoupon/checkCouponName', { params })
// 新建白名单企业
export const entWhite = params =>
  request(BASE_URL + '/serviceCoupon/couponEntList', { params })
// 编辑白名单企业
export const couponDetail = params =>
  request(BASE_URL + '/serviceCoupon/couponDetail', { params })
// 企业详情白名单列表
export const couponDetailByPage = params =>
  request(BASE_URL + '/serviceCoupon/couponDetailByPage', { params })

// 企业详情是否能创建补发券
export const judgeReissue = params =>
  request(BASE_URL + '/serviceCoupon/judgeReissue', { params })
// 领券记录-导出
export const couponRecordExport = (params, downCallBack) =>
  request.downLoad(
    BASE_URL + '/serviceCoupon/couponRecordExport',
    params,
    '',
    '',
    downCallBack
  )

// 服务机构的服务类型字典列表
export const serviceTypeDictList = params =>
  request(BASE_URL + '/serviceCoupon/serviceTypeDictList', params)

// 查询企业服务券时间设置
export const queryAll = params =>
  request(BASE_URL + '/govEntWhiteSetting/queryAll', { params })
// 查询普通机构入驻时间设置
export const queryCommonInst = params =>
  request(BASE_URL + '/govEntIntermediaryCommonSetting/queryAll', { params })
// 查询服务机构入驻时间设置
export const queryServeInst = params =>
  request(BASE_URL + '/govEntIntermediarySetting/queryAll', { params })
// 查询上传发票时间设置
export const queryInvoice = params =>
  request(BASE_URL + '/govUploadInvoiceSetting/queryAll', { params })
// 查询兑付资料设置
export const entCashQuery = params =>
  request(BASE_URL + '/entCashSetting/queryAll', { params })

// 新增/编辑白名单时间设置
export const insertOrUpdateEntWhiteSetting = data =>
  request.post(
    BASE_URL + '/govEntWhiteSetting/insertOrUpdateEntWhiteSetting',
    data
  )
// 设置发票管理上传时间
export const insertOrUpdateUploadInvoiceSetting = data =>
  request.post(
    BASE_URL + '/govUploadInvoiceSetting//insertOrUpdateUploadInvoiceSetting',
    data
  )
// 设置兑现是否开启
export const  editorCashSetting = data =>
  request.post(BASE_URL + '/entCashSetting/editorCashSetting', data)

